export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-m@2x.4a2616ff.webp";